$(function () {

    // Define variables
    const collectionProviderURL = $.p("collectionProvider", "where-buy-rcp");
    const markerIconURL = $.p("markerIcon", "where-buy-rcp");

    const pointsMap = $("#mapContainer").mapPlugin({
        markerCluster: false,
        fitBounds: true,
        markerConfig: {
            iconURL: markerIconURL,
            iconSize: [25, 32]
        }
    });

    $.ajax({
        method: "GET",
        url: collectionProviderURL,
        dataType: "json",
        timeout: 30000,
        success: function (responseData) {
            pointsMap.geoJSON(responseData);
        }
    })
});

//# sourceMappingURL=where-buy-rcp.js.map
